import React, { useEffect, useState } from "react";
import "./LoanCompare.css";
import Second_Header from "../Common_Component/Second_Header/Second_Header";
import { Form } from "react-bootstrap";
import Save_Upto_Lottie from "../animation/Save_Upto_Lottie/Save_Upto_Lottie";
import PlanCardComponent from "./PlanCardComponent/PlanCardComponent";
import CoursesBannerComponent from "./CoursesBannerComponent/CoursesBannerComponent";
import Pay_For_limited_Time_modal from "../Common_Component/Common_Modal/Pay_For_limited_Time_modal/Pay_For_limited_Time_modal";
import { LoanFormGet } from "../../utils/apis/form/form";
import Cookies from "js-cookie";
import { getData } from "../../utils/api";
const LoanCompare = () => {
  const [active, setActive] = useState("Monthly");
  const [showPayModal, setShowPayModal] = useState(false);
  const [data, setData] = useState(false);
  const [lifecover, setLifecover] = useState("75 lac");
  const [coverTillAge, setCoverTillAge] = useState("75 Yrs");
  const courses = [1, 2, 3];
  const [insurenceType, setInsurenceType] = useState(2);
  const user_data = Cookies.get("user_data"); // Get the value of 'status' cookie

  useEffect(() => {
    if (user_data){
       const parsedData = JSON.parse(user_data);
    setData(parsedData);
    }
   
  }, [user_data]);
  const [insuranceData, setIsuranceData] = useState([]);
  const numericLifeCover = parseInt(lifecover); // extracts 40 from "40 Lac"
  const numericCoverTillAge = parseInt(coverTillAge); // extracts 48 from "48 Yrs"
  const GetIsuranceData = async () => {
    const response = await getData(
      `/finance/insurance?life_cover=${numericLifeCover}&cover_till_age=${numericCoverTillAge}&insurence_type=${insurenceType}`
    );
    if (response?.success) {
      setIsuranceData(response?.data);
    }
  };
  useEffect(() => {
    GetIsuranceData();
  }, [coverTillAge, lifecover, insurenceType]);

  const [showAll, setShowAll] = useState(false);

  const handleShowMore = () => {
    setShowAll(true);
  };

  const visiblePlans = showAll
    ? insuranceData?.data
    : insuranceData?.data?.slice(0, 5);
  return (
    <section className="LoanCompare">
      <div className="second_h_holder">
        <Second_Header
          insuranceData={insuranceData}
          lifecoverdata={lifecover}
          coverTillAge={coverTillAge}
          setCoverTillAge={setCoverTillAge}
          setLifecover={setLifecover}
          setData={setData}
          data={data}
          showCompare={true}
          showFilter={true}
        />
      </div>

      <div className="container">
        <div className="more_filters_div">
          <div className="all_filter_holder">
            {/* <div
              className="save_upto_main_div"
              onClick={() => {
                setShowPayModal(true);
              }}
            >
              <p className="title_text">
                <Save_Upto_Lottie /> Save upto 42 %
              </p>

              <div className="red_btn_div">
                <p className="text">WITH LIMITED PAY</p>
              </div>
            </div> */}

            <div className="toggle-container">
              <div className="toggle-switch">
                <div
                  className={`toggle-active ${
                    insurenceType === 1 ? "shift-right" : ""
                  }`}
                ></div>
                <button
                  className={`toggle-btn ${
                    insurenceType === 2 ? "selected" : ""
                  }`}
                  onClick={() => setInsurenceType(2)}
                >
                  Monthly
                </button>
                <button
                  className={`toggle-btn ${
                    insurenceType === 1 ? "selected" : ""
                  }`}
                  onClick={() => setInsurenceType(1)}
                >
                  Yearly
                </button>
              </div>
            </div>

            {/* <div className="plan_main_div red_checkobox">
              <Form.Check // prettier-ignore
                type="checkbox"
                name="name"
                label="Plans that return my Premium"
              />
            </div> */}
          </div>
        </div>

        <div className="plans_main_div">
          <div className="row">
            <div className="col-lg-9">
              <div className="main_plan_cards_section">
                {visiblePlans?.map((val) => (
                  <PlanCardComponent val={val} />
                ))}
                {/* <PlanCardComponent />
                                <PlanCardComponent /> */}

                {!showAll && insuranceData?.data?.length > 5 && (
                  <div className="show_more_div">
                    <button
                      className="show_more_btn"
                      type="button"
                      onClick={handleShowMore}
                    >
                      Show More
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-3 ">
              <div className="main_course_section">
                <div className="row">
                  {courses?.map((item) => {
                    return (
                      <div className="col-lg-12 col-md-4 col-sm-4 col-6">
                        <CoursesBannerComponent />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Pay_For_limited_Time_modal
        insuranceData={insuranceData}
        data={data}
        show={showPayModal}
        onHide={() => {
          setShowPayModal(false);
        }}
      />
    </section>
  );
};

export default LoanCompare;
